import { conversationsConstants } from '../../constants';

const initialState = {
  socket: null,
  conversations: [],
  conversation: {
    id: null,
    name: '',
    thumbnail: '',
    subTitle: '',
    unreadCount: 0,
    messages: [],
    page: 1,
  },
  post: {},
  posts: [],
  repliesForComments: [],
  globalMessageCount: 0,
  conversationActiveTab: 'Batch / Course',
  prePopulatedMessage: '',
  prePopulatedImage: null,
  pinnedMessages: [],
  latestPinnedMessage: null,
};

export function conversations(state = initialState, action) {
  switch (action.type) {
    case conversationsConstants.SET_SOCKET:
      return {
        ...state,
        socket: action.payload.socket,
      };

    case conversationsConstants.CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload,
      };

    case conversationsConstants.SET_CONVERSATION:
      return {
        ...state,
        conversation: action.payload,
      };

    case conversationsConstants.SET_POST:
      return {
        ...state,
        post: action.payload,
      };

    case conversationsConstants.SET_POSTS:
      return {
        ...state,
        posts: action.payload,
      };

    case conversationsConstants.SET_REPLIES:
      return {
        ...state,
        repliesForComments: action.payload,
      };
    case conversationsConstants.GLOBALCOUNT:
      return {
        ...state,
        globalMessageCount: action.payload,
      };
    case conversationsConstants.ACTIVETAB:
      return {
        ...state,
        conversationActiveTab: action.payload,
      };
    case conversationsConstants.SET_PRE_POPULATED_MESSAGE:
      return {
        ...state,
        prePopulatedMessage: action.payload?.text || '',
        prePopulatedImage: action.payload?.image || null,
      };
    case conversationsConstants.SET_PINNED_MESSAGES:
      return {
        ...state,
        pinnedMessages: action.payload,
      };
    case conversationsConstants.SET_LATEST_PINNED_MESSAGE:
      return {
        ...state,
        latestPinnedMessage: action.payload,
      };
    case conversationsConstants.UPDATE_MESSAGE_PINNED_STATUS:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          messages: (state.conversation.messages || []).map((msg) =>
            msg.id === action.payload.chatId ? { ...msg, isPinned: action.payload.isPinned } : msg,
          ),
        },
      };
    case conversationsConstants.CLEAR:
      return {
        ...state,
        socket: null,
        conversations: [],
        conversation: {},
        globalMessageCount: state.globalMessageCount,
        prePopulatedMessage: '',
        prePopulatedImage: null,
        pinnedMessages: [],
        latestPinnedMessage: null,
      };
    default:
      return state;
  }
}

export const getSocket = (state) => state.conversations.socket;

export const getConversations = (state) => state.conversations.conversations;

export const getConversation = (state) => state.conversations.conversation;

export const getPost = (state) => state.conversations.post;

export const getPosts = (state) => state.conversations.posts;

export const getGlobalMessageCount = (state) => state.conversations.globalMessageCount;

export const getRepliesForComments = (state) => state.conversations.repliesForComments;

export const getConversationActiveTab = (state) => state.conversations.conversationActiveTab;

export const getPrePopulatedMessage = (state) => state.conversations.prePopulatedMessage;

export const getPrePopulatedImage = (state) => state.conversations.prePopulatedImage;

export const getPinnedMessages = (state) => state.conversations.pinnedMessages;

export const getLatestPinnedMessage = (state) => state.conversations.latestPinnedMessage;
